import { DOCUMENT_STATUS } from './../../models/User';
import { DepositTabComponent } from './deposit-tab/deposit-tab.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { QuickBarComponent } from './quick-bar/quick-bar.component';
import { ConfirmDialogComponent } from '../../../../modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ScrollStrategyOptions, BlockScrollStrategy } from '@angular/cdk/overlay';
import { DataLayerService } from '../../services/utils/data-layer.service';
import { WithdrawTabComponent } from './withdraw-tab/withdraw-tab.component';
import { Activity, ACTIVITY_TYPE } from '../../models/Activity';
import { ORDER_SUBTYPE } from '../../models/Order';
import { AuthService } from '../../abstraction/auth.service';
import { CryptoService } from '../../abstraction/crypto.service';
@Component({
  selector: 'app-user-dash',
  templateUrl: './user-dash.component.html',
  styleUrls: ['./user-dash.component.scss'],
})
export class UserDashComponent implements OnInit {
  @ViewChild(QuickBarComponent) quickbar: QuickBarComponent;

  quickStep: number;
  loadingCVU: boolean;
  successfulCVU: boolean;
  pesoAdolar: boolean;
  amount: string;
  coinValue: number;
  option: number;
  today = new Date();
  todayIso = this.today.toISOString();
  greeting = 'Buen día';
  tabIndex: number;
  depositSelected: number;
  showButtons: boolean;
  isMobile = false;
  withdrawOpened = false;
  selectedTab = 'crypto';

  constructor(
    public cryptoService: CryptoService,
    public authService: AuthService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private readonly sso: ScrollStrategyOptions,
    public data: DataLayerService,
  ) {}

  ngOnInit() {
    if (this.authService.loggedUser) this.cryptoService.getCryptoHistories();
    if (window.innerWidth <= 767) {
      this.isMobile = true;
    }

    const hour = new Date(this.todayIso).getHours();

    if (hour >= 14 && hour < 20) {
      this.greeting = 'Buenas tardes';
    } else if (hour >= 20 || hour < 4) {
      this.greeting = 'Buenas noches';
    }
    this.tabIndex = 1;
    this.depositSelected = 1;

    // console.log(this.router.url);
    // if (this.router.url === "/core?withdrawal=true") {
    //   this.openDialogWithdraw(1);
    // }

    this.activatedRoute.queryParamMap.subscribe((data) => {
      if (data.get('withdrawal')) {
        setTimeout(() => {
          this.openDialogWithdraw(data.get('withdrawal'));
        }, 300);
      }
    });
  }

  toggleButtons(status?: boolean) {
    if (window.innerWidth <= 425) {
      if (status !== undefined && status !== null) {
        if (this.showButtons) {
          this.showButtons = status;
        }
      } else {
        if (!this.showButtons || this.showButtons === null) {
          this.showButtons = true;
        } else {
          this.showButtons = false;
        }
      }
    }
  }

  showUserName(): string {
    if (this.authService.loggedUser.name) {
      return ', ' + this.authService.loggedUser.name.split(' ')[0];
    } else {
      return '';
    }
  }

  openDialogWithdraw(type?: string) {
    if (this.authService.checkOnboardingStatus()) {
      const params = {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'deposit',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        scrollStrategy: this.sso.reposition({
          autoClose: false,
          scrollThrottle: 300,
        }),
        data: undefined,
      };
      if (type !== 'all') {
        params.data = type;
      }

      const dialogRef = this.dialog.open(WithdrawTabComponent, params);
    }
  }

  openDialogDeposit() {
    if (this.authService.checkOnboardingStatus()) {
      this.dialog.open(DepositTabComponent, {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'deposit',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        scrollStrategy: this.sso.block(),
      });
    }
  }

  getState(activity: Activity) {
    if (activity.type === ACTIVITY_TYPE.ORDER) {
      switch (activity.status) {
        case 0:
          return 'En proceso';
        case 1:
          return 'Realizado';
        default:
          return 'Cancelado';
      }
    } else if (activity.type === ACTIVITY_TYPE.DEPOSIT) {
      switch (activity.status) {
        case 0:
          return 'Esperando transferencia';
        case 1:
          return 'Realizado';
        default:
          return 'Cancelado';
      }
    } else if (activity.type === ACTIVITY_TYPE.WITHDRAWAL) {
      switch (activity.status) {
        case 0:
          return 'En proceso';
        case 1:
          return 'Realizado';
        default:
          return 'Cancelado';
      }
    } else if (activity.type === ACTIVITY_TYPE.TIME_DEPOSIT) {
      switch (activity.status) {
        case 0:
        case 1:
          return 'En proceso';
        case 2:
          return 'Terminado';
        default:
          return 'Cancelado';
      }
    }
  }

  openChargeDialog() {
    //Crear charge...
  }

  // copyLinkToClipboard(){

  //   const item = this.depositSelected == 1 ? this.apiService.cbuBytelimeARS : this.apiService.cbuBytelimeUSD;

  //   const selBox = document.createElement('textarea');
  //   selBox.style.position = 'fixed';
  //   selBox.style.left = '0';
  //   selBox.style.top = '0';
  //   selBox.style.opacity = '0';
  //   selBox.value = item;
  //   document.body.appendChild(selBox);
  //   selBox.focus();
  //   selBox.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(selBox);

  //   const ref = this.dialog.open(ConfirmDialogComponent, {
  //     panelClass: 'modal-container',
  //     data: {
  //       title: 'CBU copiado al portapapeles',
  //       body: 'Transfiera el dinero desde su Homebanking',
  //       options: ['Aceptar']
  //     }
  //   });

  // }
}
